import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthEventsService {
  loggedIn = new Subject()
  unauthenticated = new Subject()
  unauthorized = new Subject()
}
